export default {
      id: "vague_organiser-usage",
      viewBox: "0 0 2000 490",
      url: "../dist/images/" + "sprite.svg#vague_organiser-usage",
      toString: function () {
        return this.url;
      }
    }